import React, { useContext } from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import { rem } from 'polished'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'
import GeoContext from 'contexts/geoContext'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { OptimizelyExperiments } from 'constants/optimizely'
import TrustIndicatorSection from 'home/components/TrustIndicatorSection/TrustIndicatorSection'
import cn from 'clsx'

const TRUST_INDICATOR_REGIONS = ['SG', 'MY', 'ZA', 'HK'] as const

const Container = styled.div`
  padding: ${rem(16)} 0;
  &.no-gap {
    margin: 0;
    padding: 0;
  }
`

function SearchPageTrustIndicators() {
  const { currentRegionCode } = useContext(GeoContext)
  const isLoggedIn = useAppSelector(selectLoggedIn)

  const [ref, inView] = useInView({ triggerOnce: true })

  // Get variation to check enrollment
  const variation = useAppSelector(state =>
    getOptimizelyExperimentVariation(state, OptimizelyExperiments.croTrustIndicatorsSearchPage),
  )

  const isEmergingMarket = TRUST_INDICATOR_REGIONS.includes(
    currentRegionCode as typeof TRUST_INDICATOR_REGIONS[number],
  )

  // Show trust indicators for logged-out users OR users in emerging markets
  const meetsTargetingCriteria = !isLoggedIn || isEmergingMarket

  // Check if user is enrolled in experiment (control or treatment) by checking variation exists
  const isEnrolledInExperiment = !!variation
  const isEnabled = isEnrolledInExperiment && meetsTargetingCriteria

  // Only trigger experiment when in view AND user meets targeting criteria and is enrolled
  useOptimizelyExperiment(
    OptimizelyExperiments.croTrustIndicatorsSearchPage,
    isEnabled && inView,
  )

  return (
    <Container ref={ref} className={cn({ 'no-gap': !isEnabled })}>
      {isEnabled && <TrustIndicatorSection />}
    </Container>
  )
}

export default React.memo(SearchPageTrustIndicators)
